import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import { defaultRejectHandler, stringifyErrorMessage} from '../../utils/utility';
import { searchBoilerByText } from '../../redux/boiler/boiler_actions';

import {
  listBoilerInBuilding,
  addBoilerToBuilding,
  editBoilerInBuilding,
  removeBoilerFromBuilding,
} from '../../redux/projects/project_boiler_actions';
import { getProject } from '../../redux/projects/projects_actions';


export class BoilerDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'boiler.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'boiler.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchBoilerByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('efficiency')}</b>,
        accessor: 'boiler.efficiency',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        width: 80,
        ...decimalColumn,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {};
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listBoiler(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      buildingId,
      filtered,
      filteredCount,
      isBoilerLoading,
      addBoiler,
      editBoiler,
      removeBoiler,
      isBoilerAdding,
      isBoilerEditing,
      isBoilerRemoving,
      errorMessage,
    } = this.props;

    const relationship = {
      create: ({ entityId, quantity }) => addBoiler(entityId, buildingId, quantity),
      edit: ({ id, quantity }) => editBoiler(id, quantity),
      delete: id => removeBoiler(id, buildingId),
      isCreating: isBoilerAdding,
      isEditing: isBoilerEditing,
      isDeleting: isBoilerRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={this.columns}
          data={this.props.relationships}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.boiler.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isBoilerLoading}
          onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  relationships: state.projectBoiler.orderedIds.map(id => state.projectBoiler.objects[id]),
  filteredCount: state.projectBoiler.filteredCount,
  isBoilerAdding: state.projectBoiler.isCreating,
  isBoilerEditing: state.projectBoiler.isEditing,
  isBoilerRemoving: state.projectBoiler.isDeleting,
  isBoilerLoading: state.projectBoiler.isLoading,
  errorMessage: state.projectBoiler.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listBoiler: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listBoilerInBuilding(pageSize, page, sorted, filtered, isPublic, props.buildingId))),
  addBoiler: (boilerId, buildingId, quantity) =>
    defaultRejectHandler(dispatch(addBoilerToBuilding(boilerId, buildingId, quantity))
      .then(() => dispatch(getProject(props.projectId)))),
  editBoiler: (projectBoilerId, quantity) =>
    defaultRejectHandler(dispatch(editBoilerInBuilding(projectBoilerId, quantity))),
  removeBoiler: (projectBoilerId, buildingId) =>
    defaultRejectHandler(dispatch(removeBoilerFromBuilding(projectBoilerId, buildingId))
      .then(() => dispatch(getProject(props.projectId)))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BoilerDataTable),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/BoilerDataTable.js